import React from 'react'
import { PricingPlan } from '../types'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { PricingPlanElement } from '../pricingPlan'
import { Typography } from '@mui/material'
import './migratePricingPlanModal.scss'
import ActionButton from 'uiComponents/buttons'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import { LucideIcon } from 'utils/lucideIcon'

interface MigratePricingPlanModalProps {
    migratingPricingPlan: PricingPlan
    activePricingPlan: PricingPlan
    onMigrate: () => void
    onDismiss: () => void
}

export const MigratePricingPlanModal = ({
    migratingPricingPlan,
    activePricingPlan,
    onMigrate,
    onDismiss,
}: MigratePricingPlanModalProps) => {
    const migrationDetails = (() => {
        const activePricingPlanAnnualPlan = activePricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1Y')
        const activePricingPlanMonthlyPlan = activePricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1M')
        const migratingPaymentPlanAnnualPlanMembers = migratingPricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1Y')?.memberCount ?? 0
        const migratingPaymentPlanMonthlyPlanMembers = migratingPricingPlan.paymentPlans.find((plan) => plan.paymentInterval === 'P1M')?.memberCount ?? 0

        if (activePricingPlanAnnualPlan && activePricingPlanMonthlyPlan) {
            return `${migratingPaymentPlanAnnualPlanMembers + migratingPaymentPlanMonthlyPlanMembers} members will migrate upon renewal`
        } else if (activePricingPlanAnnualPlan) {
            return `${migratingPaymentPlanAnnualPlanMembers} members on an annual plan will migrate upon renewal`
        }
        return `${migratingPaymentPlanMonthlyPlanMembers} members on a monthly plan will migrate upon renewal`
    })()

    return (
        <Modal title="Migrate pricing plan" onDismiss={onDismiss} className="migrate-pricing-plan-modal">
            <ModalBody>
                <Typography variant="body1">
                    Members on this plan who have auto-renewal enabled will migrate to the active
                    plan upon their next renewal. This happens gradually and can take up to a year.
                    <br /><br />
                    You can stop this migration at any time. Members who have already renewed into
                    the new plan will not be moved back.
                </Typography>
                <div className="pricing-plan-container">
                    <label className="plan-label">From</label>
                    <PricingPlanElement pricingPlan={migratingPricingPlan} readOnly />
                    <div className="migration-details">
                        <Typography variant="body1">{migrationDetails}</Typography> <LucideIcon iconName="ArrowDown" />
                    </div>
                    <label className="plan-label">To</label>
                    <PricingPlanElement pricingPlan={activePricingPlan} readOnly />
                </div>
            </ModalBody>
            <ModalFooter>
                <CancelButton onClick={onDismiss} size="large" />
                <ActionButton size="large" onClick={onMigrate}>
                    Migrate
                </ActionButton>
            </ModalFooter>
        </Modal>
    )
}
